import { Mic } from 'lucide-react-native';
import { Text, VStack } from '../../../components/primitives';
import { Button } from '../../../components/primitives/Button';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';

// "Coming soon" placeholder only — per design.md B3/B4, the live ConvAI
// voice interview (transcript capture, OrganizationProfile extraction) is
// an explicit non-goal of this change. This component starts NO session,
// opens NO WebSocket, and extracts NO fields.
interface VoiceOnboardingScaffoldProps {
  onContinueGuided: () => void;
}

export function VoiceOnboardingScaffold({
  onContinueGuided,
}: Readonly<VoiceOnboardingScaffoldProps>) {
  const { t } = useTranslation();

  return (
    <VStack spacing="md" align="center" testID="onboarding-voice-scaffold">
      <Mic size={48} color={colors.primary[500]} strokeWidth={2} />
      <Text variant="h4" color={colors.text.primary}>
        {t('onboardingWizard.modality.voiceScaffoldTitle')}
      </Text>
      <Text variant="body" color={colors.text.secondary}>
        {t('onboardingWizard.modality.voiceScaffoldSubtitle')}
      </Text>
      <Button
        testID="onboarding-voice-scaffold-continue-guided"
        variant="secondary"
        onPress={onContinueGuided}
        accessibilityLabel={t('onboardingWizard.modality.continueGuided')}
      >
        {t('onboardingWizard.modality.continueGuided')}
      </Button>
    </VStack>
  );
}
